import React, { useEffect, useState } from 'react'
import ArrowUpSvg from '@/shared/assets/images/ArrowUp.svg'

interface SidebarSubProps {
    children: React.ReactNode,
    icon: React.FC<React.SVGProps<SVGSVGElement>>
    title: string
    defaultOpen?: boolean
}

export const SidebarSub: React.FC<SidebarSubProps> = ({ children, icon: Icon, title, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState<boolean>(defaultOpen)

    useEffect(() => {
        if (defaultOpen) {
            setIsOpen(true)
        }
    }, [defaultOpen])

    return (
        <div>
            <button 
                onClick={() => setIsOpen(prev => !prev)} 
                className={`w-full pl-6 items-center flex h-[36px]`}
            >
                <div className={`w-[24px] h-[24px] fill-white`}>
                    {<Icon width={24} height={24}/>}
                </div>
                <div className={`ml-[6px] text-nowrap overflow-hidden overflow-ellipsis text-base`}>
                    {title}
                </div>
                <div className='ml-auto mr-3'>
                    <ArrowUpSvg width={20} height={20} className={`transition  ${isOpen ? 'rotate-0' : 'rotate-180'}`}/>
                </div>
            </button>
            {isOpen &&
                <div className='flex mt-2 pl-4 flex-col gap-2'>
                    {children}
                </div>
            }
        </div>
    )
}
